import type { types } from '@bedc/types';

import { profiles } from './profiles';

/**
 * Get the telemetry profile of an environment.
 *
 * Feature-branch stacks run as `rome-<ticket>`, which the environment type stands for with
 * `rome1234`.
 *
 * @param environment The environment the code is built for or running in.
 * @returns Its telemetry profile.
 */
export const getTelemetryProfile = (
	environment: types.environment.Environment
): types.telemetry.Profile =>
	Object.hasOwn(profiles, environment) ? profiles[environment] : profiles.rome1234;

/**
 * Remove the query and fragment from a URL, since either can hold a search term.
 *
 * @param text Any text. Only an http(s) URL is changed.
 * @returns The URL without its query and fragment, or the text unchanged.
 */
export const withoutUrlQuery = (text: string): string =>
	/^https?:\/\//.test(text) ? text.replace(/[?#].*/s, '') : text;
